export default {
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'h1'
    }
  },
  render (h, { props, data, children }) {
    const sizes = {
      h1: 'text-2xl',
      h2: 'text-2xl',
      h3: 'text-2xl',
      h4: 'text-2xl',
      h5: 'text-xl'
    }
    data.staticClass = (data.staticClass || '') +
      ` ${sizes[props.tag]}`
    return h(props.tag, data, children)
  }
}
